var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalMantenedor",
    { attrs: { show: _vm.show } },
    [
      _c("CabeceraModal", {
        attrs: { titulo: "Corregir Incumplimientos" },
        on: { cerrar: _vm.handleCerrar }
      }),
      _c("br"),
      _c(
        "div",
        { staticClass: "orden_compra", attrs: { align: "center" } },
        [
          _c(
            "v-flex",
            { attrs: { md10: "" } },
            [
              _c(
                "v-card",
                { staticClass: "rounded-card" },
                [
                  _c(
                    "v-form",
                    {
                      ref: "form",
                      staticClass: "col-md-12",
                      attrs: { "lazy-validation": "" }
                    },
                    [
                      _c(
                        "v-container",
                        { attrs: { "grid-list-md": "" } },
                        [
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", sm4: "", md4: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Transportista",
                                      readonly: "",
                                      "prepend-icon": "home_repair_service"
                                    },
                                    model: {
                                      value: _vm.transportista,
                                      callback: function($$v) {
                                        _vm.transportista = $$v
                                      },
                                      expression: "transportista"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", sm4: "", md4: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Flota",
                                      readonly: "",
                                      "prepend-icon": "home_repair_service"
                                    },
                                    model: {
                                      value: _vm.flota,
                                      callback: function($$v) {
                                        _vm.flota = $$v
                                      },
                                      expression: "flota"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", sm4: "", md4: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Patente",
                                      readonly: "",
                                      "prepend-icon": "home_repair_service"
                                    },
                                    model: {
                                      value: _vm.patente,
                                      callback: function($$v) {
                                        _vm.patente = $$v
                                      },
                                      expression: "patente"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                {
                                  staticStyle: { "margin-left": "5px" },
                                  attrs: { xs12: "" }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "medidas-container" },
                                    [
                                      _c(
                                        "v-icon",
                                        { staticClass: "medidas-icon" },
                                        [_vm._v("description")]
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "medidas-title" },
                                        [
                                          _vm._v(
                                            "Medidas correctivas aplicadas"
                                          )
                                        ]
                                      ),
                                      _c("div", {
                                        staticClass: "medidas-textarea",
                                        domProps: {
                                          innerHTML: _vm._s(_vm.medidas)
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              ),
                              _c(
                                "v-flex",
                                {
                                  staticStyle: { "margin-left": "5px" },
                                  attrs: { xs12: "" }
                                },
                                [
                                  _c("v-textarea", {
                                    ref: "textarea",
                                    attrs: {
                                      label: "Data corregida",
                                      rows: "4",
                                      "prepend-icon": "description"
                                    },
                                    model: {
                                      value: _vm.datoenvio,
                                      callback: function($$v) {
                                        _vm.datoenvio = $$v
                                      },
                                      expression: "datoenvio"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "text-right",
                                  staticStyle: { "margin-top": "-10px" },
                                  attrs: { xs12: "" }
                                },
                                [
                                  _c(
                                    "v-layout",
                                    { attrs: { "justify-end": "" } },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { color: "primary" },
                                          on: { click: _vm.showConfirmation }
                                        },
                                        [_vm._v("Enviar")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "v-flex",
                                {
                                  staticStyle: { "margin-left": "5px" },
                                  attrs: { xs12: "" }
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "medidas-container medidas-container-large"
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        { staticClass: "medidas-icon" },
                                        [_vm._v("description")]
                                      ),
                                      _c(
                                        "span",
                                        { staticClass: "medidas-title" },
                                        [_vm._v("Respuesta integrador")]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "medidas-textarea" },
                                        [_vm._v(_vm._s(_vm.respuestaEnvio))]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("Confirmation", {
                attrs: {
                  show: _vm.showDialog,
                  titulo: _vm.confirmationTitle,
                  mensaje: _vm.confirmationMessage,
                  textoBtnSi: _vm.$t("Confirmar"),
                  textoBtnNo: _vm.$t("Cancelar")
                },
                on: { modalConfirmationEmit: _vm.handleConfirmationResponse }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }